import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Radios, Button, ErrorSummary } from 'govuk-react-jsx';
import {
  getBuildingTypeSelected,
  setBuildingTypeSelected,
} from '../../features/application/applicationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getUserDetails } from '../../features/dashboard/dashboardSlice';
import useTitle from '../../hooks/useTitle';

const BuildingType = ({ location }) => {
  const isFromCheckAnswers = location?.state?.isFromCheckAnswers;
  const buildingTypeSelectedRedux = useSelector(getBuildingTypeSelected);
  const dispatch = useDispatch();
  const history = useHistory();
  const [hasError, setHasError] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const currentUserData = useSelector(getUserDetails);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'landlordApp.BuildingType.s10',
    'What best describes your property? - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const errorMsg = copyProvider.getCopy(
    'landlordApp.BuildingType.s2',
    'Select an option'
  );

  const handleRadioSelection = (event) => {
    dispatch(setBuildingTypeSelected(event.target.value));
  };

  const handleButtonClick = () => {
    if (!buildingTypeSelectedRedux) {
      setHasError(true);
      setErrorList([{ children: errorMsg, href: '#individual ' }]);
    } else {
      setHasError(false);

      if (isFromCheckAnswers) {
        history.push('/landlordApp/check-your-answers');
      } else {
        history.push('/landlordApp/number-of-chargepoints');
      }
    }
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <div>
        <span className="govuk-caption-l">
          {currentUserData != null &&
            currentUserData.business_name != null &&
            currentUserData.business_name}
        </span>
        <h1 className="govuk-heading-xl">
          {copyProvider.getCopy(
            'landlordApp.BuildingType.s1',
            'What best describes your property?'
          )}
        </h1>

        <Radios
          onChange={handleRadioSelection}
          value={buildingTypeSelectedRedux}
          errorMessage={
            hasError && {
              children: errorMsg,
            }
          }
          idPrefix="buildingType"
          items={[
            {
              children: [
                <span key="0" className="govuk-label govuk-!-margin-bottom-1">
                  {copyProvider.getCopy(
                    'landlordApp.BuildingType.s3',
                    'Individual flat or apartment building'
                  )}
                </span>,
              ],
              value: 'individual-flat-or-apartment-building',
              id: 'individual',
            },
            {
              children: [
                <span key="2" className="govuk-label govuk-!-margin-bottom-1">
                  {copyProvider.getCopy(
                    'landlordApp.BuildingType.s5',
                    'Detached property'
                  )}
                </span>,
              ],
              value: 'detached-property',
              id: 'detached',
            },
            {
              children: [
                <span key="3" className="govuk-label govuk-!-margin-bottom-1">
                  {copyProvider.getCopy(
                    'landlordApp.BuildingType.s6',
                    'Semi-detached property'
                  )}
                </span>,
              ],
              value: 'semi-detached-property',
              id: 'semi',
            },
            {
              children: [
                <span key="4" className="govuk-label govuk-!-margin-bottom-1">
                  {copyProvider.getCopy(
                    'landlordApp.BuildingType.s7',
                    'Terraced property'
                  )}
                </span>,
              ],
              value: 'terraced-property',
              id: 'terraced',
            },
            {
              children: [
                <span key="5" className="govuk-label govuk-!-margin-bottom-1">
                  {copyProvider.getCopy(
                    'landlordApp.BuildingType.s8',
                    'Bungalow'
                  )}
                </span>,
              ],
              value: 'bungalow',
              id: 'bungalow',
            },
          ]}
          name="buildingType"
        />
        <Button onClick={handleButtonClick}>
          {copyProvider.getCopy('landlordApp.BuildingType.s9', 'Continue')}
        </Button>
      </div>
    </>
  );
  return pageModel;
};
BuildingType.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      isFromCheckAnswers: PropTypes.bool,
    }),
  }),
};

BuildingType.defaultProps = {
  location: {
    state: {
      isFromCheckAnswers: false,
    },
  },
};
export default BuildingType;
